/*****************************************************************************************
 * 설명 : 자격검정관리 > 합격자 목록 > 합격증 출력
 * URI : /admin/cert/pass/print1
 * 작성자 :
 * 작성일 :
*****************************************************************************************/
import React, {useEffect, useState} from 'react';
import Restful from 'service/restful';
import { Button } from '@mui/material';
import qs from 'qs';

import './passPrint.scss';
import backLogo from '../../../../assets/images/admin/back_logo.png';
import signImage from '../../../../assets/images/admin/sign.png';

/*****************************************************************************************
 * 설명 : 함수 선언
*****************************************************************************************/
const PassCertificationPrint = (props) => {

  /***************************************************************************************
   * 설명 : 변수 선언부
  ***************************************************************************************/
  const [getApi] = Restful();

  const [query, setQuery] = useState({});
  const [data, setData] = useState({});

  const PrintData = [
    {
      documentNo : '국가공인 제2023-2호',
      certName : '시스템에어컨설계시공관리사',
      certTxt : '국가공인 시스템에어컨설계시공관리사',
      certNameE : 'System AirCondition Design & Install Manager',
      certTxtE : 'System Air conditioning.',
    },
    {
      documentNo : '국가공인 제2023-1호',
      certName : '냉매취급관리사',
      certTxt : '국가공인 냉매취급관리사',
      certNameE : 'Refrigerant Manager',
      certTxtE : 'Refrigerant Manager.',
    },
    {
      documentNo : '등록번호 제 2019-004658 호',
      certName : '가정용에어컨설치관리사',
      certTxt : '가정용에어컨설치관리분야',
      certNameE : 'Household Air-conditioner installation manager',
      certTxtE : 'Household Air-conditioner installation manager.',
    },
  ];

  const [type, setType] = useState(0);

  /***************************************************************************************
   * 설명 : 데이터 가져오기
  ***************************************************************************************/
  const getList = () => {
    console.log("=== getList 함수 시작 ===");
    console.log("query:", query);

    let params = {
      program: 'admin',
      service: 'application',
      action: 'getContinueCertificationPrint',
      version: '1.0',
      seq: query.seq,
      type: query.type
    }

    console.log("API 호출 파라미터:", params);

    getApi("get", params).then( response => {
      console.log("API 응답:", response);
      console.log("API 응답 전체 구조:", JSON.stringify(response, null, 2));

      if( response !== undefined && response.data ) {
        console.log("response.data:", response.data);
        console.log("response.data.result:", response.data.result);
        console.log("response.data.data:", response.data.data);

        if( response.data.result && response.data.data ) {
          console.log("데이터 설정:", response.data.data[0]);
          setData(response.data.data[0]);
          const typeValue = parseInt(query.type) || 0;
          setType(typeValue === 3 ? 2 : typeValue);
        } else {
          console.log("API 응답에서 데이터를 찾을 수 없음");
          console.log("result:", response.data.result);
          console.log("data:", response.data.data);
          setData({});
        }
      } else {
        console.log("response.data가 없음");
        setData({});
      }
    }).catch(error => {
      console.error("API 호출 에러:", error);
    })
  }

  /***************************************************************************************
   * 설명 : 데이터 불러오기
  ***************************************************************************************/
  useEffect(() => {
    if( data.seq !== undefined && query?.isReportPrint === '1') {
      window.print();
    }
    // eslint-disable-next-line
  }, [data]);

  /***************************************************************************************
   * 설명 : 데이터 로딩
  ***************************************************************************************/
  useEffect(() => {
    console.log("=== query useEffect 실행 ===");
    console.log("query.seq:", query.seq);
    console.log("query:", query);

    if( query.seq !== undefined && query.seq !== '' ) {
      console.log("getList 호출");
      getList();
    } else {
      console.log("query.seq가 없어서 getList 호출하지 않음");
    }
    // eslint-disable-next-line
  }, [query])

  /***************************************************************************************
   * 설명 : 데이터 로딩
  ***************************************************************************************/
  useEffect(() => {
    console.log("=== 컴포넌트 초기화 useEffect 실행 ===");
    console.log("props.seq:", props.seq);
    console.log("window.location.search:", window.location.search);

    let tmp = {};

    // props로 seq가 전달된 경우
    if (props.seq) {
      tmp = { seq: props.seq };
    } else {
      // URL에서 파싱
      tmp = qs.parse(window.location.search, {
        ignoreQueryPrefix: true
      });
    }

    console.log("파싱된 query:", tmp);
    setQuery(tmp);

  }, [props.seq]);

  /***************************************************************************************
   * 설명 : html 선언부
  ***************************************************************************************/
  console.log("=== 컴포넌트 렌더링 ===");
  console.log("현재 data:", data);
  console.log("현재 type:", type);
  console.log("현재 query:", query);

  console.log("배경 로고 URL:", backLogo);
  console.log("서명 이미지 URL:", signImage);

  return (
    <section style={{
      '--back-logo-url': `url(${backLogo})`,
      '--sign-image-url': `url(${signImage})`
    }}>
      <section className="btn-area">
        <Button
          variant="contained"
          color="primary"
          className="Btn"
          onClick={() => window.print()}
        >출력</Button>
        <Button
          variant="outlined"
          className="Btn ml10"
          onClick={() => window.close()}
        >이전으로 돌아가기</Button>
      </section>

      <section>
        <section
          className="print-body pass-print"
          style={{
            backgroundImage: `url(${backLogo})`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center center',
            backgroundSize: '70%',
            backgroundAttachment: 'local'
          }}
        >
          <div className="document-no">{PrintData[type]?.documentNo || PrintData[0].documentNo}</div>
          <h2 className="print-title">자&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;격&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;증</h2>

          <table className="info1-table">
            <caption className="hidden">합격정보</caption>
            <colgroup>
              <col width="70px" />
              <col width="calc(50% - 70px)" />
              <col width="70px" />
              <col width="calc(50% - 70px)" />
            </colgroup>
            <tbody>
            <tr>
              <th scope="row"><label>자&nbsp;&nbsp;격&nbsp;&nbsp;명 :</label></th>
              <td>{PrintData[type]?.certName || PrintData[0].certName}</td>
              <th scope="row"><label>자격번호 :</label></th>
              <td>제 {data.passNumber} 호</td>
            </tr>
            <tr>
              <th scope="row"><label>성&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;명 :</label></th>
              <td>{data.userName}</td>
              <th scope="row"><label>발&nbsp;&nbsp;행&nbsp;&nbsp;일 :</label></th>
              <td>{data.issueDate}</td>
            </tr>
            <tr>
              <th scope="row"><label>주민번호 :</label></th>
              <td>{data.iden}</td>
              <th scope="row"><label>유효기간 :</label></th>
              <td>{data.expirePeriod}</td>
            </tr>
            <tr>
              <th scope="row"><label>주&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;소 :</label></th>
              <td colSpan={3}>{data.address}</td>
            </tr>
            </tbody>
          </table>

          <div className="cert-txt">귀하는 한국냉동공조산업협회가 시행하는 {PrintData[type]?.certTxt || PrintData[0].certTxt} 자격검정에 합격하였으므로 이 자격 증서를 드립니다.</div>

          <div className="com1">
            <p>위 사람은 본 협회에서 시행하는 자격검정에 합격하였으므로</p>
            <p>자격기본법 제23조에 의거 이 자격증서를 수여합니다.</p>
            <p>2024년 01월 01일</p>
          </div>

          <div className="sign"></div>

          <h3 className="print-titleE">CERTIFICATE</h3>

          <ul className="info2-table">
            <li>Name&nbsp;&nbsp;:&nbsp;&nbsp;{data?.userNameEn}</li>
            <li>Date of Birth&nbsp;&nbsp;:&nbsp;&nbsp;{data?.iden}</li>
            <li>Certificate No.&nbsp;&nbsp;:&nbsp;&nbsp;{data?.passNumber}</li>
            <li>Address&nbsp;&nbsp;:&nbsp;&nbsp;{data?.address}</li>
            <li>Period of Validity&nbsp;&nbsp;:&nbsp;&nbsp;{data?.expirePeriod}</li>
            <li>Field&nbsp;&nbsp;:&nbsp;&nbsp;{PrintData[type]?.certNameE || PrintData[0].certNameE}</li>
          </ul>

          <div className="cert-txtE">The Korea Refrigeration and Air-Conditioning Industry Association issues this Certificate to the above-mentioned in recognition of having passed the examination in the field of {PrintData[type]?.certTxtE || PrintData[0].certTxtE}</div>

          <div className="comE">
            <p>Korea Refrigeration and Air-Conditioning Industry Association</p>
            <p>January 01, 2024</p>
          </div>

          <div className="ceoE">
            <p>President&nbsp;&nbsp;Kim Seong-rak</p>
          </div>
          <div className="sign"></div>
        </section>
      </section>

    </section>
  );
}

/*****************************************************************************************
 * 설명 : default export 선언
*****************************************************************************************/
export default PassCertificationPrint;